import { bindable } from 'aurelia-framework';
import { IImportAM } from './import-api';
import { ITargetToServiceAM } from '../services/service-targetings/linked-mappings-service';

export class ImportEntryButtons {
	@bindable cancelImport: () => void;
	@bindable cancelImportKeepAutomationResults: () => void;
	@bindable remapImport: () => void;
	@bindable executeImport: () => Promise<boolean>;
	@bindable importEntry: IImportAM;
	@bindable stagedCount: number;
	@bindable errorCount: number;
	@bindable importStatus: string;
	@bindable remapEnabled: boolean;

	@bindable autoTargetEnabled: boolean;
	@bindable itemsToTarget: ITargetToServiceAM[] = [];
	@bindable executeAutoTarget: () => void;

	cancelImportVisible = true;
	remapImportVisible = true;
	executeImportVisible = true;
	executeAutoTargetVisible = true;
	loading = false;

	setCancelImportActionable = this.setActionable(() => { this.cancelImportVisible = true; });
	setExecuteImportActionable = this.setActionable(() => { this.executeImportVisible = true; });
	setExecuteAutoTargetActionable = this.setActionable(() => { this.executeAutoTargetVisible = true; });

	async cancelImportProxy() {
		this.loading = true;
		await this.cancelImport();
	}

	async cancelImportKeepAutomationResultsProxy() {
		this.loading = true;
		await this.cancelImportKeepAutomationResults();
	}

	async remapImportProxy() {
		this.loading = true;
		await this.remapImport();
		this.loading = false;
	}

	async executeImportProxy() {
		this.loading = true;
		// On success the page navigates away; on a refusal the buttons come back
		if (!await this.executeImport()) {
			this.loading = false;
		}
	}

	async executeAutoTargetProxy() {
		this.loading = true;
		await this.executeAutoTarget();
		this.loading = false;
	}

	private setActionable(setVisible: () => void) {
		return (actionable: boolean) => {
			if (actionable) {
				this.cancelImportVisible = false;
				this.remapImportVisible = false;
				this.executeImportVisible = false;
				this.executeAutoTargetVisible = false;
				setVisible();
			} else {
				this.cancelImportVisible = true;
				this.remapImportVisible = true;
				this.executeImportVisible = true;
				this.executeAutoTargetVisible = true;
			}
		};
	}
}

export interface ISetActionableParams {
	actionable: boolean;
}
